export const projects = [
  {
    name: '10-Plex Professional Center',
    category: 'Commercial Development',
    detail: 'Home to ten independent Southwest Florida businesses.',
    year: '2024',
    image:
      'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1400&q=80',
  },
  {
    name: 'Two-Unit Flex Space',
    category: 'Commercial Development',
    detail: '10,400 sq ft of adaptable warehouse and office space.',
    year: '2023',
    image:
      'https://images.unsplash.com/photo-1545558014-8692077e9b5c?w=1000&q=80',
  },
  {
    name: 'Multipurpose Building',
    category: 'Commercial Development',
    detail: '10,500 sq ft, steel structure with a CastCrete roof system.',
    year: '2022',
    image:
      'https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=1000&q=80',
  },
  {
    name: 'Residential Communities',
    category: 'Residential Development',
    detail: 'Two- and three-story homes across Southwest Florida.',
    year: '2006 – Present',
    image:
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1000&q=80',
  },
  {
    name: 'Site Development',
    category: 'Land Development',
    detail: 'Entitlements, site work and infrastructure for future builds.',
    year: 'Ongoing',
    image:
      'https://images.unsplash.com/photo-1577495508048-b635879837f1?w=1000&q=80',
  },
]
